export default __webpack_public_path__ + "static/univers-rounded-roman-b10782f0fd2a378369448136ce4cd69f.woff2";